import { ExpressionType } from './ExpressionType';
export var ConstantExpressionType;
(function (ConstantExpressionType) {
    ConstantExpressionType[ConstantExpressionType["Object"] = -2] = "Object";
    ConstantExpressionType[ConstantExpressionType["Array"] = -1] = "Array";
    ConstantExpressionType[ConstantExpressionType["Null"] = 0] = "Null";
    ConstantExpressionType[ConstantExpressionType["Boolean"] = 1] = "Boolean";
    ConstantExpressionType[ConstantExpressionType["Number"] = 2] = "Number";
    ConstantExpressionType[ConstantExpressionType["String"] = 3] = "String";
    ConstantExpressionType[ConstantExpressionType["Date"] = 4] = "Date";
})(ConstantExpressionType || (ConstantExpressionType = {}));
const NullExpression = {
    type: ConstantExpressionType.Null,
    nodeType: ExpressionType.Constant,
    value: undefined
};
export { NullExpression };
